import React from "react";

export default function SuccessSVGMailDark() {
  return (
    <svg
      width="248"
      height="270"
      viewBox="0 0 248 270"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_249_13151)">
        <path
          d="M238.896 108.021C238.81 108.021 238.726 107.99 238.655 107.93L122.209 9.97093C121.855 9.67421 121.434 9.51564 121.003 9.51653C120.572 9.51741 120.151 9.67772 119.797 9.9759L4.19031 107.929C4.09887 108.007 3.9857 108.037 3.87569 108.014C3.76568 107.991 3.66784 107.915 3.6037 107.805C3.53957 107.694 3.51438 107.558 3.53368 107.425C3.55299 107.292 3.61521 107.174 3.70665 107.096L119.314 9.14296C119.809 8.72557 120.398 8.5012 121.001 8.5C121.605 8.49881 122.194 8.72083 122.691 9.13625L239.136 107.095C239.21 107.157 239.265 107.246 239.294 107.348C239.323 107.451 239.324 107.562 239.297 107.665C239.271 107.769 239.217 107.859 239.145 107.923C239.072 107.987 238.985 108.021 238.896 108.021Z"
          fill="#DEE2E4"
        />
        <path
          d="M10.7949 111.493L121.116 12.7305L232.274 118.521L126.8 194.049L69.5368 178.282L10.7949 111.493Z"
          fill="#DEE2E4"
        />
        <path
          d="M74.373 240.699H19.8718C19.5371 240.7 19.2057 240.621 18.8964 240.466C18.5871 240.312 18.306 240.085 18.0692 239.8C17.8324 239.514 17.6446 239.175 17.5164 238.802C17.3882 238.428 17.3223 238.028 17.3223 237.624C17.3223 237.219 17.3882 236.819 17.5164 236.446C17.6446 236.072 17.8324 235.733 18.0692 235.447C18.306 235.162 18.5871 234.935 18.8964 234.781C19.2057 234.626 19.5371 234.547 19.8718 234.548H74.373C74.7076 234.547 75.0391 234.626 75.3484 234.781C75.6577 234.935 75.9388 235.162 76.1756 235.447C76.4124 235.733 76.6002 236.072 76.7284 236.446C76.8566 236.819 76.9225 237.219 76.9225 237.624C76.9225 238.028 76.8566 238.428 76.7284 238.802C76.6002 239.175 76.4124 239.514 76.1756 239.8C75.9388 240.085 75.6577 240.312 75.3484 240.466C75.0391 240.621 74.7076 240.7 74.373 240.699Z"
          fill="#0BEC9F"
        />
        <path
          d="M39.4256 227.476H19.8718C19.5371 227.476 19.2057 227.397 18.8964 227.243C18.5871 227.088 18.306 226.862 18.0692 226.576C17.8324 226.291 17.6446 225.951 17.5164 225.578C17.3882 225.204 17.3223 224.804 17.3223 224.4C17.3223 223.996 17.3882 223.595 17.5164 223.222C17.6446 222.849 17.8324 222.509 18.0692 222.224C18.306 221.938 18.5871 221.712 18.8964 221.557C19.2057 221.403 19.5371 221.324 19.8718 221.324H39.4256C39.7603 221.324 40.0917 221.403 40.401 221.557C40.7103 221.712 40.9914 221.938 41.2282 222.224C41.465 222.509 41.6529 222.849 41.781 223.222C41.9092 223.595 41.9751 223.996 41.9751 224.4C41.9751 224.804 41.9092 225.204 41.781 225.578C41.6529 225.951 41.465 226.291 41.2282 226.576C40.9914 226.862 40.7103 227.088 40.401 227.243C40.0917 227.397 39.7603 227.476 39.4256 227.476Z"
          fill="#0BEC9F"
        />
        <path
          d="M122.67 166.503C122.256 166.504 121.846 166.407 121.462 166.217L53.4238 132.116V25.3727C53.4247 24.4288 53.7355 23.5239 54.2881 22.8565C54.8406 22.189 55.5898 21.8136 56.3712 21.8125H186.897C187.679 21.8136 188.428 22.1891 188.981 22.8565C189.533 23.5239 189.844 24.4288 189.845 25.3727V132.19L189.717 132.257L123.915 166.201C123.521 166.401 123.098 166.504 122.67 166.503Z"
          fill="white"
        />
        <path
          d="M122.67 166.757C122.228 166.757 121.79 166.654 121.381 166.452L53.2129 132.285V25.3722C53.2138 24.3608 53.5468 23.3913 54.1389 22.6761C54.7309 21.961 55.5336 21.5588 56.3708 21.5576H186.897C187.734 21.5588 188.537 21.961 189.129 22.6761C189.721 23.3913 190.054 24.3608 190.055 25.3722V132.358L123.997 166.434C123.577 166.647 123.126 166.757 122.67 166.757ZM54.055 131.606L121.703 165.512C122.334 165.821 123.04 165.816 123.668 165.498L189.213 131.686V25.3722C189.212 24.6305 188.968 23.9195 188.534 23.3951C188.1 22.8707 187.511 22.5757 186.897 22.5748H56.3708C55.7568 22.5757 55.1682 22.8707 54.7341 23.3951C54.3 23.9195 54.0557 24.6305 54.055 25.3722L54.055 131.606Z"
          fill="#DEE2E4"
        />
        <path
          d="M238.053 107.004H237.968L189.632 131.936L123.497 166.048C123.238 166.179 122.961 166.248 122.681 166.25C122.4 166.251 122.123 166.186 121.863 166.058L53.6316 131.865L4.10732 107.045L4.03166 107.004H3.94737C3.16594 107.005 2.41677 107.38 1.86422 108.048C1.31167 108.715 1.00087 109.62 1 110.564V265.18C1.00087 266.124 1.31167 267.029 1.86422 267.697C2.41677 268.364 3.16594 268.74 3.94737 268.741H238.053C238.834 268.74 239.583 268.364 240.136 267.697C240.688 267.029 240.999 266.124 241 265.18V110.564C240.999 109.62 240.688 108.715 240.136 108.048C239.583 107.38 238.834 107.005 238.053 107.004ZM240.158 265.18C240.158 265.855 239.936 266.501 239.541 266.978C239.146 267.455 238.611 267.723 238.053 267.723H3.94737C3.38909 267.723 2.85374 267.455 2.45897 266.978C2.06421 266.501 1.84233 265.855 1.84211 265.18V110.564C1.84287 109.907 2.05405 109.275 2.43149 108.801C2.80893 108.327 3.32341 108.047 3.86739 108.021L53.6316 132.963L121.539 166.999C122.274 167.36 123.098 167.355 123.83 166.984L189.632 133.039L238.137 108.021C238.68 108.049 239.193 108.33 239.569 108.803C239.946 109.277 240.157 109.908 240.158 110.564V265.18Z"
          fill="#DEE2E4"
        />
        <rect x="77" y="46.5" width="89" height="88" rx="44" fill="#ECFDF5" />
        <path
          d="M117.485 107.853C116.5 107.855 115.542 107.537 114.754 106.948L114.705 106.911L104.419 99.0523C103.943 98.688 103.543 98.2337 103.243 97.7153C102.942 97.1969 102.747 96.6245 102.668 96.0308C102.59 95.4371 102.629 94.8338 102.784 94.2552C102.939 93.6766 103.206 93.1342 103.571 92.6588C103.936 92.1834 104.391 91.7845 104.911 91.4847C105.43 91.1849 106.004 90.9901 106.599 90.9115C107.194 90.8329 107.798 90.872 108.378 91.0266C108.958 91.1812 109.502 91.4483 109.978 91.8125L116.64 96.9105L132.384 76.4202C132.75 75.945 133.205 75.5462 133.725 75.2465C134.244 74.9469 134.818 74.7524 135.413 74.674C136.008 74.5956 136.612 74.635 137.192 74.7898C137.772 74.9446 138.315 75.2118 138.791 75.5762L138.694 75.7089L138.794 75.5782C139.755 76.3149 140.383 77.4019 140.542 78.6005C140.7 79.7992 140.376 81.0116 139.64 81.9719L121.121 106.073C120.692 106.629 120.142 107.078 119.511 107.387C118.881 107.696 118.187 107.855 117.485 107.853Z"
          fill="#0BEC9F"
        />
        <g clipPath="url(#clip1_249_13151)">
          <mask
            id="mask0_249_13151"
            maskUnits="userSpaceOnUse"
            x="197"
            y="34"
            width="12"
            height="13">
            <path d="M209 34.5H197V46.5H209V34.5Z" fill="white" />
          </mask>
          <g mask="url(#mask0_249_13151)">
            <path
              d="M203 34.5C203.204 37.7256 205.774 40.2963 209 40.5C205.774 40.7037 203.204 43.2744 203 46.5C202.796 43.2744 200.226 40.7037 197 40.5C200.226 40.2963 202.796 37.7256 203 34.5Z"
              fill="url(#paint0_linear_249_13151)"
            />
          </g>
        </g>
        <g clipPath="url(#clip2_249_13151)">
          <mask
            id="mask1_249_13151"
            maskUnits="userSpaceOnUse"
            x="146"
            y="0"
            width="12"
            height="13">
            <path d="M158 0.5H146V12.5H158V0.5Z" fill="white" />
          </mask>
          <g mask="url(#mask1_249_13151)">
            <path
              d="M152 0.5C152.204 3.72558 154.774 6.29631 158 6.5C154.774 6.7037 152.204 9.2744 152 12.5C151.796 9.2744 149.226 6.7037 146 6.5C149.226 6.29631 151.796 3.72558 152 0.5Z"
              fill="url(#paint1_linear_249_13151)"
            />
          </g>
        </g>
        <g clipPath="url(#clip3_249_13151)">
          <mask
            id="mask2_249_13151"
            maskUnits="userSpaceOnUse"
            x="11"
            y="15"
            width="38"
            height="39">
            <path d="M49 15.5H11V53.5H49V15.5Z" fill="white" />
          </mask>
          <g mask="url(#mask2_249_13151)">
            <path
              d="M30 15.5C30.6451 25.7143 38.7856 33.855 49 34.5C38.7856 35.1451 30.6451 43.2856 30 53.5C29.355 43.2856 21.2143 35.1451 11 34.5C21.2143 33.855 29.355 25.7143 30 15.5Z"
              fill="url(#paint2_linear_249_13151)"
            />
          </g>
        </g>
        <g clipPath="url(#clip4_249_13151)">
          <mask
            id="mask3_249_13151"
            maskUnits="userSpaceOnUse"
            x="210"
            y="144"
            width="29"
            height="31">
            <path d="M239 144.5H210V174.5H239V144.5Z" fill="white" />
          </mask>
          <g mask="url(#mask3_249_13151)">
            <path
              d="M224.5 144.5C224.992 152.564 231.205 158.991 239 159.5C231.205 160.009 224.992 166.436 224.5 174.5C224.008 166.436 217.795 160.009 210 159.5C217.795 158.991 224.008 152.564 224.5 144.5Z"
              fill="url(#paint3_linear_249_13151)"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_249_13151"
          x1="203"
          y1="34.5"
          x2="203"
          y2="46.5"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FC4C4C" />
          <stop offset="1" stopColor="#FFDBB0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_249_13151"
          x1="152"
          y1="0.5"
          x2="152"
          y2="12.5"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FC4C4C" />
          <stop offset="1" stopColor="#FFDBB0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_249_13151"
          x1="30"
          y1="15.5"
          x2="30"
          y2="53.5"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FC4C4C" />
          <stop offset="1" stopColor="#FFDBB0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_249_13151"
          x1="224.5"
          y1="144.5"
          x2="224.5"
          y2="174.5"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FC4C4C" />
          <stop offset="1" stopColor="#FFDBB0" />
        </linearGradient>
        <clipPath id="clip0_249_13151">
          <rect width="247" height="269" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
        <clipPath id="clip1_249_13151">
          <rect width="12" height="12" fill="white" transform="translate(197 34.5)" />
        </clipPath>
        <clipPath id="clip2_249_13151">
          <rect width="12" height="12" fill="white" transform="translate(146 0.5)" />
        </clipPath>
        <clipPath id="clip3_249_13151">
          <rect width="38" height="38" fill="white" transform="translate(11 15.5)" />
        </clipPath>
        <clipPath id="clip4_249_13151">
          <rect width="29" height="30" fill="white" transform="translate(210 144.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
